import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

/**
 * Where the gateway sends the browser back after a hosted checkout started from the app, and
 * the hosted page's back/cancel button target for every channel (?cancelled=1).
 *
 * In a child window (web portal checkout) it tells the opener and closes itself; the opener
 * settles or cancels the payment. Otherwise (native in-app browser) it says to return to the app.
 *
 * The portal's own confirmation page is behind the auth guard, and the in-app browser has no
 * session, so a native taxpayer would land on a login screen straight after paying. This page is
 * public and says nothing about the outcome — the app resolves that itself (checkout/complete)
 * once the in-app browser is dismissed.
 */
@Component({
  selector: 'app-checkout-return',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="cr">
      <mat-icon class="cr__icon" [class.cr__icon--cancel]="cancelled">{{ cancelled ? 'cancel' : 'check_circle' }}</mat-icon>
      <h2 class="cr__title">{{ cancelled ? 'Payment cancelled' : 'All set' }}</h2>
      <p class="cr__msg">
        {{ cancelled
          ? 'Nothing was charged. Close this window to return to the app and try again when you are ready.'
          : 'Close this window to return to the app, where your payment confirmation will be waiting.' }}
      </p>
    </div>
  `,
  styles: [`
    .cr { min-height: 100vh; display: flex; flex-direction: column; align-items: center;
          justify-content: center; gap: 16px; padding: 24px; text-align: center; }
    .cr__icon { font-size: 56px; height: 56px; width: 56px; color: #2e7d32; }
    .cr__icon--cancel { color: #c62828; }
    .cr__title { margin: 0; }
    .cr__msg { margin: 0; color: rgba(0,0,0,.6); max-width: 360px; }
  `],
})
export class CheckoutReturnComponent implements OnInit {
  cancelled = false;

  ngOnInit(): void {
    this.cancelled = new URLSearchParams(window.location.search).get('cancelled') === '1';
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage({ tdtCheckout: 'returned', cancelled: this.cancelled }, window.location.origin);
      window.close();
    }
  }
}
